{{'result.found_records' | translate}}: <span class="app-font-bold" *ngIf="state.searchResults">{{state.numFound}}</span>
